var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Detail',{ref:"detailResf",attrs:{"initData":_vm.works}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }